export var IdLoca;
(function (IdLoca) {
    IdLoca["__branch"] = "__branch";
    IdLoca["__deployTime"] = "__deployTime";
    IdLoca["__versionNumber"] = "__versionNumber";
    IdLoca["accountSaveDialog_facebook_noSuccess_desc"] = "accountSaveDialog_facebook_noSuccess_desc";
    IdLoca["AccountSaveDialogSuccess_title"] = "AccountSaveDialogSuccess_title";
    IdLoca["adventureFarm"] = "adventureFarm";
    IdLoca["alert_anErrorOccurred_title"] = "alert_anErrorOccurred_title";
    IdLoca["alert_connectionLost_desc"] = "alert_connectionLost_desc";
    IdLoca["alert_connectionLost_title"] = "alert_connectionLost_title";
    IdLoca["alert_serverDowntime_desc"] = "alert_serverDowntime_desc";
    IdLoca["alert_serverDowntime_title"] = "alert_serverDowntime_title";
    IdLoca["anotherSaveFound_confirmConnection_serverAccount"] = "anotherSaveFound_confirmConnection_serverAccount";
    IdLoca["anotherSaveFound_confirmConnection_thisDeviceAccount"] = "anotherSaveFound_confirmConnection_thisDeviceAccount";
    IdLoca["anotherSaveFound_confirmConnection_title"] = "anotherSaveFound_confirmConnection_title";
    IdLoca["anotherSaveFound_loginViaFb_serverAccount_web"] = "anotherSaveFound_loginViaFb_serverAccount_web";
    IdLoca["anotherSaveFound_loginViaFb_title"] = "anotherSaveFound_loginViaFb_title";
    IdLoca["anotherSaveFound_onTheServer"] = "anotherSaveFound_onTheServer";
    IdLoca["anotherSaveFound_onThisDevice_web"] = "anotherSaveFound_onThisDevice_web";
    IdLoca["anotherSaveFound_title"] = "anotherSaveFound_title";
    IdLoca["bestProjectContribution"] = "bestProjectContribution";
    IdLoca["buy"] = "buy";
    IdLoca["buyGold"] = "buyGold";
    IdLoca["Gold"] = "gold";
    IdLoca["buyMaterials"] = "buyMaterials";
    IdLoca["cafeAndStore_thresholdRewardDesc"] = "cafeAndStore_thresholdRewardDesc";
    IdLoca["cafeAndStore_thresholdRewardTitle"] = "cafeAndStore_thresholdRewardTitle";
    IdLoca["cafeCelebration_desc"] = "cafeCelebration_desc";
    IdLoca["cafeCelebration_title"] = "cafeCelebration_title";
    IdLoca["cancel"] = "cancel";
    IdLoca["cancelProjectConfirmation_desc"] = "cancelProjectConfirmation_desc";
    IdLoca["cancelProjectConfirmation_title"] = "cancelProjectConfirmation_title";
    IdLoca["category_couponShop"] = "category_couponShop";
    IdLoca["choose"] = "choose";
    IdLoca["choosePlayerNameDialog_desc"] = "choosePlayerNameDialog_desc";
    IdLoca["choosePlayerNameDialog_enterTextField"] = "choosePlayerNameDialog_enterTextField_web";
    IdLoca["choosePlayerNameDialog_title"] = "choosePlayerNameDialog_title";
    IdLoca["collect"] = "collect";
    IdLoca["collectAndAgain"] = "collectAndAgain";
    IdLoca["collectForMany"] = "collectForMany";
    IdLoca["comingSoon"] = "floatingText_comingSoon";
    IdLoca["compensationDialog_desc"] = "compensationDialog_desc";
    IdLoca["compensationDialog_title"] = "compensationDialog_title";
    IdLoca["confirm"] = "confirm";
    IdLoca["confirmation"] = "confirmation";
    IdLoca["confirmLeaderChange_desc"] = "confirmLeaderChange_desc";
    IdLoca["confirmLeaderChange_title"] = "confirmLeaderChange_title";
    IdLoca["congratulations"] = "congratulations";
    IdLoca["contracts_category1"] = "contracts_category1";
    IdLoca["contracts_unlockAvailable"] = "contracts_unlockAvailable";
    IdLoca["contractsNew_desc"] = "contractsNew_desc";
    IdLoca["contractsNew_title"] = "contractsNew_title";
    IdLoca["cooperative"] = "cooperative";
    IdLoca["cooperativeLeader"] = "cooperativeLeader";
    IdLoca["coopHelp_availablePoints"] = "coopHelp_availablePoints";
    IdLoca["coopHelp_desc"] = "coopHelp_desc";
    IdLoca["coopHelp_loyaltypointCooldown"] = "coopHelp_loyaltypointCooldown";
    IdLoca["coopInvitationDialog_desc1"] = "coopInvitationDialog_desc1";
    IdLoca["coopInvitationDialog_desc2"] = "coopInvitationDialog_desc2";
    IdLoca["coopInvitationDialog_title"] = "coopInvitationDialog_title";
    IdLoca["coopInvite_alert_expired"] = "coopInvite_alert_expired";
    IdLoca["coopInvite_alert_fullCoop"] = "coopInvite_alert_fullCoop";
    IdLoca["coopInvite_alert_notExisting"] = "coopInvite_alert_notExisting";
    IdLoca["coopInvite_alert_title"] = "coopInvite_alert_title";
    IdLoca["coopInviteConfirmationDialog_desc"] = "coopInviteConfirmationDialog_desc";
    IdLoca["coopLanguage_title"] = "coopLanguage_title";
    IdLoca["coopLeague"] = "coopLeague";
    IdLoca["coopProjects_projects"] = "coopProjects_projects";
    IdLoca["coopProject_successful"] = "coopProject_successful";
    IdLoca["coopRank"] = "coopRank";
    IdLoca["coopSystemMessage_projectStart"] = "coopSystemMessage_projectStart";
    IdLoca["coopSystemMessage_projectSuccessful"] = "coopSystemMessage_projectSuccessful";
    IdLoca["coopSystemMessage_projectCancelled"] = "coopSystemMessage_projectCancelled";
    IdLoca["coopSystemMessage_projectFailed"] = "coopSystemMessage_projectFailed";
    IdLoca["coopSystemMessage_coopLevelUp"] = "coopSystemMessage_coopLevelUp";
    IdLoca["coopSystemMessage_playerJoined"] = "coopSystemMessage_playerJoined";
    IdLoca["coopSystemMessage_invitedPlayerJoined"] = "coopSystemMessage_invitedPlayerJoined";
    IdLoca["coopSystemMessage_playerLeft"] = "coopSystemMessage_playerLeft";
    IdLoca["coopSystemMessage_playerKicked"] = "coopSystemMessage_playerKicked";
    IdLoca["coopSystemMessage_appointedDeputy"] = "coopSystemMessage_appointedDeputy";
    IdLoca["coopSystemMessage_newLeader"] = "coopSystemMessage_newLeader";
    IdLoca["coopSystemMessage_donatedFunds"] = "coopSystemMessage_donatedFunds";
    IdLoca["coopSystemMessage_improvementUpgraded"] = "coopSystemMessage_improvementUpgraded";
    IdLoca["coopSystemMessage_improvementStarted"] = "coopSystemMessage_improvementStarted";
    IdLoca["cultivate"] = "cultivate";
    IdLoca["currentBonus"] = "currentBonus";
    IdLoca["deupty"] = "deputy";
    IdLoca["difficultyX"] = "difficultyX";
    IdLoca["divination"] = "divination";
    IdLoca["dog_treat"] = "dogTreat";
    IdLoca["dog_treat_plural"] = "dogTreat_plural";
    IdLoca["doghouse_info"] = "dogTreats_helpText_desc";
    IdLoca["dogTreat_premium"] = "dogTreat_premium";
    IdLoca["editCoop_category"] = "editCoop_category";
    IdLoca["empty"] = "";
    IdLoca["enterCoopDesc_desc"] = "enterCoopDesc_desc";
    IdLoca["enterCoopDesc_title"] = "enterCoopDesc_title";
    IdLoca["enterCoopName_desc"] = "enterCoopName_desc";
    IdLoca["enterCoopName_title"] = "enterCoopName_title";
    IdLoca["enterCoopNotice_input_web"] = "enterCoopNotice_input_web";
    IdLoca["error_atLeastOneLetter"] = "error_atLeastOneLetter";
    IdLoca["error_badwordInDesc"] = "error_badwordInDesc";
    IdLoca["error_badwordInName"] = "error_badwordInName";
    IdLoca["error_disconnected_desc_web"] = "error_disconnected_desc_web";
    IdLoca["error_disconnected_title"] = "error_disconnected_title";
    IdLoca["error_internalServerError_desc"] = "error_internalServerError_desc";
    IdLoca["error_internalServerError_title"] = "error_internalServerError_title";
    IdLoca["error_invalidCharacters"] = "error_invalidCharacters";
    IdLoca["error_nameAlreadyExists"] = "error_nameAlreadyExists";
    IdLoca["error_nameTooShort"] = "error_nameTooShort";
    IdLoca["event_asian_category1"] = "event_asian_category1";
    IdLoca["event_asian_desc"] = "event_asian_desc";
    IdLoca["event_asian_title"] = "event_asian_title";
    IdLoca["event_camping_category1"] = "event_camping_category1";
    IdLoca["event_camping_desc"] = "event_camping_desc";
    IdLoca["event_camping_title"] = "event_camping_title";
    IdLoca["event_christmas_category1"] = "event_christmas_category1";
    IdLoca["event_christmas_desc"] = "event_christmas_desc";
    IdLoca["event_christmas_title"] = "event_christmas_title";
    IdLoca["event_easter_category1"] = "event_easter_category1";
    IdLoca["event_easter_desc"] = "event_easter_desc";
    IdLoca["event_easter_title"] = "event_easter_title";
    IdLoca["event_fairytale_category1"] = "event_fairytale_category1";
    IdLoca["event_fairytale_desc"] = "event_fairytale_desc";
    IdLoca["event_fairytale_title"] = "event_fairytale_title";
    IdLoca["event_farmCup_category1"] = "event_farmCup_category1";
    IdLoca["event_farmCup_desc"] = "event_farmCup_desc";
    IdLoca["event_farmCup_title"] = "event_farmCup_title";
    IdLoca["event_foodTruck_category1"] = "event_foodTruck_category1";
    IdLoca["event_foodTruck_desc"] = "event_foodTruck_desc";
    IdLoca["event_foodTruck_title"] = "event_foodTruck_title";
    IdLoca["event_halloween_category1"] = "event_halloween_category1";
    IdLoca["event_halloween_desc"] = "event_halloween_desc";
    IdLoca["event_halloween_title"] = "event_halloween_title";
    IdLoca["event_hawaii_category1"] = "event_hawaii_category1";
    IdLoca["event_hawaii_desc"] = "event_hawaii_desc";
    IdLoca["event_hawaii_title"] = "event_hawaii_title";
    IdLoca["event_ufo_category1"] = "event_ufo_category1";
    IdLoca["event_ufo_desc"] = "event_ufo_desc";
    IdLoca["event_ufo_title"] = "event_ufo_title";
    IdLoca["event_wedding_category1"] = "event_wedding_category1";
    IdLoca["event_wedding_desc"] = "event_wedding_desc";
    IdLoca["event_wedding_title"] = "event_wedding_title";
    IdLoca["eventCompleted_asian_desc"] = "eventCompleted_asian_desc";
    IdLoca["eventCompleted_camping_desc"] = "eventCompleted_camping_desc";
    IdLoca["eventCompleted_christmas_desc"] = "eventCompleted_christmas_desc";
    IdLoca["eventCompleted_easter_desc"] = "eventCompleted_easter_desc";
    IdLoca["eventCompleted_fairytale_desc"] = "eventCompleted_fairytale_desc";
    IdLoca["eventCompleted_farmCup_desc"] = "eventCompleted_farmCup_desc";
    IdLoca["eventCompleted_foodTruck_desc"] = "eventCompleted_foodTruck_desc";
    IdLoca["eventCompleted_halloween_desc"] = "eventCompleted_halloween_desc";
    IdLoca["eventCompleted_hawaii_desc"] = "eventCompleted_hawaii_desc";
    IdLoca["eventCompleted_ufo_desc"] = "eventCompleted_ufo_desc";
    IdLoca["eventCompleted_wedding_desc"] = "eventCompleted_wedding_desc";
    IdLoca["exclusiveGold_web"] = "exclusiveGold_web";
    IdLoca["expansionDialog_title"] = "expansionDialog_title";
    IdLoca["expansionDialog_unlock"] = "expansionDialog_unlock";
    IdLoca["feedbackDialog_desc_web"] = "feedbackDialog_desc_web";
    IdLoca["feedbackDialog_input_web"] = "feedbackDialog_input_web";
    IdLoca["floatingText_collectAfterPurchase"] = "floatingText_collectAfterPurchase";
    IdLoca["floatingText_completedProjectsNeeded"] = "floatingText_completedProjectsNeeded";
    IdLoca["floatingText_coopInviteDisabled"] = "floatingText_coopInviteDisabled";
    IdLoca["floatingText_coopInviteJoinedAlready"] = "floatingText_coopInviteJoinedAlready";
    IdLoca["floatingText_coopInviteNotRequLevel"] = "floatingText_coopInviteNotRequLevel";
    IdLoca["floatingText_coopInviteOpen"] = "floatingText_coopInviteOpen";
    IdLoca["floatingText_coopInviteOpenFromUs"] = "floatingText_coopInviteOpenFromUs";
    IdLoca["floatingText_coopInviteSuccessful"] = "floatingText_coopInviteSuccessful";
    IdLoca["floatingText_coopNotFound"] = "floatingText_coopNotFound";
    IdLoca["floatingText_coopXplevelup"] = "floatingText_coopXplevelup";
    IdLoca["floatingText_expansionDollar"] = "floatingText_expansionDollar";
    IdLoca["floatingText_featureNotAvailableYet"] = "floatingText_featureNotAvailableYet";
    IdLoca["floatingText_feedbackSent"] = "floatingText_feedbackSent";
    IdLoca["floatingText_fortuneTellerEventFinished"] = "floatingText_fortuneTellerEventFinished";
    IdLoca["floatingText_leadersAndDeputiesOnly"] = "floatingText_leadersAndDeputiesOnly";
    IdLoca["floatingText_levelCap"] = "floatingText_levelCap";
    IdLoca["floatingText_MemberInProbationary"] = "floatingText_MemberInProbationary";
    IdLoca["floatingText_playerNotFound"] = "floatingText_playerNotFound";
    IdLoca["floatingText_requCoopLevel"] = "floatingText_requCoopLevel";
    IdLoca["floatingText_themedEventNotRunning"] = "floatingText_themedEventNotRunning";
    IdLoca["floatingText_xplevelup"] = "floatingText_xplevelup";
    IdLoca["found"] = "found";
    IdLoca["free"] = "free";
    IdLoca["freeInTime"] = "freeInTime";
    IdLoca["fortuneTellerEvent_title"] = "fortuneTellerEvent_title";
    IdLoca["fortuneTellerEvent_desc"] = "fortuneTellerEvent_desc";
    IdLoca["fortuneTellerEventFinished_desc"] = "fortuneTellerEventFinished_desc";
    IdLoca["fortuneTellerBestReward_desc"] = "fortuneTellerBestReward_desc";
    IdLoca["fortuneTellerEvent_chances_desc"] = "fortuneTellerEvent_chances_desc";
    IdLoca["fortuneTellerEvent_reward_title"] = "fortuneTellerEvent_reward_title";
    IdLoca["give"] = "give";
    IdLoca["growingGoldPOs_helpText_desc"] = "growingGoldPOs_helpText_desc";
    IdLoca["growingGoldPOs_helpText_title"] = "growingGoldPOs_helpText_title";
    IdLoca["growingDollarPOs_helpText_desc"] = "growingDollarPOs_helpText_desc";
    IdLoca["growingDollarPOs_helpText_title"] = "growingDollarPOs_helpText_title";
    IdLoca["growingSeaweedPOs_helpText_desc"] = "growingSeaweedPOs_helpText_desc";
    IdLoca["growingSeaweedPOs_helpText_title"] = "growingSeaweedPOs_helpText_title";
    IdLoca["gwContext_attack"] = "gwContext_attack";
    IdLoca["gwContext_chanceToWin"] = "gwContext_chanceToWin";
    IdLoca["gwContext_notAdjacent"] = "gwContext_notAdjacent";
    IdLoca["gwContext_reinforce"] = "gwContext_reinforce";
    IdLoca["gwContext_reinforcements"] = "gwContext_reinforcements";
    IdLoca["gwContext_reinforcementsIncoming"] = "gwContext_reinforcementsIncoming";
    IdLoca["gwContext_to"] = "gwContext_to";
    IdLoca["gwContext_underAttack"] = "gwContext_underAttack";
    IdLoca["gwContext_vs"] = "gwContext_vs";
    IdLoca["gwMenu_collectedGoonsTitle"] = "gwMenu_collectedGoonsTitle";
    IdLoca["gwMenu_currentRank"] = "gwMenu_currentRank";
    IdLoca["gwMenu_desc"] = "gwMenu_desc";
    IdLoca["gwMenu_qualification"] = "gwMenu_qualification";
    IdLoca["gwMenu_title"] = "gwMenu_title";
    IdLoca["gwMenuOngoing_desc"] = "gwMenuOngoing_desc";
    IdLoca["gwReward_desc"] = "gwReward_desc";
    IdLoca["gwReward_title"] = "gwReward_title";
    IdLoca["gwTeaser_unlock_desc"] = "gwTeaser_unlock_desc";
    IdLoca["help_happiness_desc1"] = "help_happiness_desc1";
    IdLoca["help_happiness_desc2"] = "help_happiness_desc2";
    IdLoca["help_happiness_desc3"] = "help_happiness_desc3";
    IdLoca["help_happiness_title"] = "help_happiness_title";
    IdLoca["help_missingPlayerlevel_desc"] = "help_missingPlayerlevel_desc";
    IdLoca["help_missingWorkers_desc"] = "help_missingWorkers_desc";
    IdLoca["help_missingWorkers_title"] = "help_missingWorkers_title";
    IdLoca["help_workers_desc1"] = "help_workers_desc1";
    IdLoca["help_workers_desc2"] = "help_workers_desc2";
    IdLoca["help_workers_desc3"] = "help_workers_desc3";
    IdLoca["help_workers_title"] = "help_workers_title";
    IdLoca["hooray"] = "hooray";
    IdLoca["humus_context_web"] = "humus_context_web";
    IdLoca["instant"] = "instant";
    IdLoca["inStorage"] = "inStorage";
    IdLoca["invite"] = "invite";
    IdLoca["iosManualUpdateDialog_title"] = "iosManualUpdateDialog_title";
    IdLoca["join"] = "join";
    IdLoca["joinCoop_blockedProjects_desc"] = "joinCoop_blockedProjects_desc";
    IdLoca["joinCoop_blockedTournament_desc"] = "joinCoop_blockedTournament_desc";
    IdLoca["kick"] = "kick";
    IdLoca["kickMember_desc"] = "kickMember_desc";
    IdLoca["kickMemberCoop_title"] = "kickMemberCoop_title";
    IdLoca["launchGiftDialog_desc"] = "launchGiftDialog_desc";
    IdLoca["league0"] = "league_0";
    IdLoca["league1"] = "league_1";
    IdLoca["league2"] = "league_2";
    IdLoca["league3"] = "league_3";
    IdLoca["league4"] = "league_4";
    IdLoca["leagueRewardOfferTitle"] = "leagueReward_offer_title";
    IdLoca["leagueMenuRewardGift"] = "leagueMenu_rewardGift";
    IdLoca["leagueMenuRewardGoldPackage"] = "leagueMenu_rewardGoldPackage";
    IdLoca["leagueMenuRewardOffer"] = "leagueMenu_rewardOffer";
    IdLoca["leagueReward_gift_title"] = "leagueReward_gift_title";
    IdLoca["leagueReward_goldPackage_desc"] = "leagueReward_goldPackage_desc";
    IdLoca["leagueReward_goldPackage_title"] = "leagueReward_goldPackage_title";
    IdLoca["coopLeagueReward_goldPackage_title"] = "coopLeagueReward_goldPackage_title";
    IdLoca["coopLeagueReward_goldPackage_desc"] = "coopLeagueReward_goldPackage_desc";
    IdLoca["collectLeague_goldPackage_title"] = "collectLeague_goldPackage_title";
    IdLoca["collectLeagueReward_goldPackage_desc"] = "collectLeagueReward_goldPackage_desc";
    IdLoca["leave"] = "leave";
    IdLoca["leaveCoop_desc"] = "leaveCoop_desc";
    IdLoca["leaveCoop_title"] = "leaveCoop_title";
    IdLoca["levelUpDialog_title"] = "levelUpDialog_title";
    IdLoca["levelX"] = "levelX";
    IdLoca["logout_confirmation_web"] = "logout_confirmation_web";
    IdLoca["market_fulfillContracts"] = "market_fulfillContracts";
    IdLoca["market_requiredMarketLevel"] = "market_requiredMarketLevel";
    IdLoca["maxLevelReached"] = "maxLevelReached";
    IdLoca["maxLimitReached"] = "maxLimitReached";
    IdLoca["member"] = "member";
    IdLoca["members"] = "members";
    IdLoca["mobilePromotionDialogue_title_web"] = "mobilePromotionDialogue_title_web";
    IdLoca["mobilePromotionDialogueA_desc_web"] = "mobilePromotionDialogueA_desc_web";
    IdLoca["mobilePromotionDialogueB_desc_web"] = "mobilePromotionDialogueB_desc_web";
    IdLoca["mobilePromotionDialogueC_desc_web"] = "mobilePromotionDialogueC_desc_web";
    IdLoca["new"] = "new";
    IdLoca["nextTimeCollect"] = "nextTimeCollect";
    IdLoca["nextUpgrade"] = "nextUpgrade";
    IdLoca["noCooperative"] = "noCooperative";
    IdLoca["notEnoughGoldDialog_desc"] = "notEnoughGoldDialog_desc";
    IdLoca["notEnoughGoldDialog_title"] = "notEnoughGoldDialog_title";
    IdLoca["notEnoughMaterialsDialog_desc"] = "notEnoughMaterialsDialog_desc";
    IdLoca["notEnoughMaterialsDialog_title"] = "notEnoughMaterialsDialog_title";
    IdLoca["notEnoughResourcesDialog_desc"] = "notEnoughResourcesDialog_desc";
    IdLoca["notEnoughResourcesDialog_desc2"] = "notEnoughResourcesDialog_desc2";
    IdLoca["notEnoughResourcesDialog_title"] = "notEnoughResourcesDialog_title";
    IdLoca["help_notEnoughTournamentCoins_title"] = "help_notEnoughTournamentCoins_title";
    IdLoca["help_notEnoughTournamentCoins_desc"] = "help_notEnoughTournamentCoins_desc";
    IdLoca["offers_subscriptionBonus"] = "offers_subscriptionBonus";
    IdLoca["okay"] = "okay";
    IdLoca["open"] = "open";
    IdLoca["overview"] = "overview";
    IdLoca["place"] = "place";
    IdLoca["playerLeague"] = "playerLeague";
    IdLoca["points"] = "points";
    IdLoca["pointsX_of_Y"] = "pointsX_of_Y";
    IdLoca["possibleRewards"] = "possibleRewards";
    IdLoca["profileDialog_title"] = "profileDialog_title";
    IdLoca["selectProfilePictureTitle"] = "profilePictureDialog_title";
    IdLoca["profilepictures_info"] = "profilepictures_info";
    IdLoca["profilePictures"] = "profilePictures";
    IdLoca["purchase_amount_web"] = "purchase_amount_web";
    IdLoca["purchase_checkOut_btn_web"] = "purchase_checkOut_btn_web";
    IdLoca["purchase_desc_web"] = "purchase_desc_web";
    IdLoca["purchase_disclaimer1_web"] = "purchase_disclaimer1_web";
    IdLoca["purchase_disclaimer2_web"] = "purchase_disclaimer2_web";
    IdLoca["purchase_disclaimer3_web"] = "purchase_disclaimer3_web";
    IdLoca["purchase_disclaimer4_web"] = "purchase_disclaimer4_web";
    IdLoca["purchase_disclaimer5_web"] = "purchase_disclaimer5_web";
    IdLoca["purchase_paymentMethod_web"] = "purchase_paymentMethod_web";
    IdLoca["purchase_privacyPolicy_web"] = "purchase_privacyPolicy_web";
    IdLoca["purchase_termsConditions_web"] = "purchase_termsConditions_web";
    IdLoca["purchase_vatIncluded_web"] = "purchase_vatIncluded_web";
    IdLoca["purchase_withdrawal_web"] = "purchase_withdrawal_web";
    IdLoca["purchase_yourOrder_web"] = "purchase_yourOrder_web";
    IdLoca["purchase_tax_desc_web"] = "purchase_tax_desc_web";
    IdLoca["purchaseOffer_bonusGold"] = "purchaseOffer_bonusGold";
    IdLoca["purchaseOffer_bonusWorthGold"] = "purchaseOffer_bonusWorthGold";
    IdLoca["purchaseOffer_purchaseReward_desc"] = "purchaseOffer_purchaseReward_desc";
    IdLoca["purchasePointsEvent_reward_desc"] = "purchasePointsEvent_reward_desc";
    IdLoca["purchasePointsEvent_reward_title"] = "purchasePointsEvent_reward_title";
    IdLoca["purchasePointsEvent_desc"] = "purchasePointsEvent_desc";
    IdLoca["purchasePointsEvent_finished"] = "purchasePointsEvent_finished";
    IdLoca["purchasePointsEvent_title"] = "purchasePointsEvent_title";
    IdLoca["quest_tutorial_welcome_title"] = "quest_tutorial_welcome_title";
    IdLoca["quickSkipDialog_constr_desc1"] = "quickSkipDialog_constr_desc1";
    IdLoca["quickSkipDialog_constr_desc2"] = "quickSkipDialog_constr_desc2";
    IdLoca["quickSkipDialog_constr_title"] = "quickSkipDialog_constr_title";
    IdLoca["quickSkipDialog_prod_desc1"] = "quickSkipDialog_prod_desc1";
    IdLoca["quickSkipDialog_prod_desc2"] = "quickSkipDialog_prod_desc2";
    IdLoca["quickSkipDialog_prod_title"] = "quickSkipDialog_prod_title";
    IdLoca["rankingMenu_category1"] = "rankingMenu_category1";
    IdLoca["rankingMenu_level"] = "rankingMenu_level";
    IdLoca["rankingMenu_name"] = "rankingMenu_name";
    IdLoca["rankingMenu_nameRankSearch"] = "rankingMenu_nameRankSearch";
    IdLoca["rankingMenu_rank"] = "rankingMenu_rank";
    IdLoca["rankingReward_collectingEvent_desc"] = "rankingReward_collectingEvent_desc";
    IdLoca["rankings_rangeRanksXToY"] = "rankings_rangeRanksXToY";
    IdLoca["rankings_singleRankX"] = "rankings_singleRankX";
    IdLoca["reachLevelX"] = "reachLevelX";
    IdLoca["recommendedLevel"] = "recommendedLevel";
    IdLoca["reconnect"] = "reconnect";
    IdLoca["reject"] = "reject";
    IdLoca["requiredLevel"] = "requiredLevel";
    IdLoca["requirement"] = "requirement";
    IdLoca["research_requiredLibraryLevel"] = "research_requiredLibraryLevel";
    IdLoca["restartConfDialog_desc_web"] = "restartConfDialog_desc_web";
    IdLoca["rewardDialog_traderEvent_desc"] = "rewardDialog_traderEvent_desc";
    IdLoca["reward_collectingEvent_title"] = "reward_collectingEvent_title";
    IdLoca["rewards"] = "rewards";
    IdLoca["save"] = "save";
    IdLoca["scarletSnow"] = "scarletSnow";
    IdLoca["searchCoop_desc"] = "searchCoop_desc";
    IdLoca["selectLanguage"] = "selectLanguage";
    IdLoca["selectMemberRank_title"] = "selectMemberRank_title";
    IdLoca["sell"] = "sell";
    IdLoca["send"] = "send";
    IdLoca["settingsMenu_ambientSoundOff"] = "settingsMenu_ambientSoundOff";
    IdLoca["settingsMenu_ambientSoundOn"] = "settingsMenu_ambientSoundOn";
    IdLoca["settingsMenu_blog_url"] = "settingsMenu_blog_url";
    IdLoca["settingsMenu_category1"] = "settingsMenu_category1";
    IdLoca["settingsMenu_connected"] = "settingsMenu_connected";
    IdLoca["settingsMenu_disconnected"] = "settingsMenu_disconnected";
    IdLoca["settingsMenu_facebook_url"] = "settingsMenu_facebook_url";
    IdLoca["settingsMenu_feedback"] = "settingsMenu_feedback";
    IdLoca["settingsMenu_musicOff"] = "settingsMenu_musicOff";
    IdLoca["settingsMenu_musicOn"] = "settingsMenu_musicOn";
    IdLoca["settingsMenu_soundOff"] = "settingsMenu_soundOff";
    IdLoca["settingsMenu_soundOn"] = "settingsMenu_soundOn";
    IdLoca["settingsMenu_support"] = "settingsMenu_support";
    IdLoca["showAll"] = "showAll";
    IdLoca["showMe"] = "showMe";
    IdLoca["showMore"] = "showMore";
    IdLoca["skip"] = "skip";
    IdLoca["smallPackages_title_sms"] = "smallPackages_title_sms";
    IdLoca["sonyPromotion_desc"] = "sonyPromotion_desc";
    IdLoca["sonyPromotion_title"] = "sonyPromotion_title";
    IdLoca["spendGoldConfDialog_desc"] = "spendGoldConfDialog_desc";
    IdLoca["spendGoldConfDialog_title"] = "spendGoldConfDialog_title";
    IdLoca["stageX"] = "stageX";
    IdLoca["start"] = "start";
    IdLoca["startEvent"] = "startEvent";
    IdLoca["startProjectConfirmation_desc"] = "startProjectConfirmation_desc";
    IdLoca["startProjectConfirmation_title"] = "startProjectConfirmation_title";
    IdLoca["status"] = "status";
    IdLoca["storageFull1_cafe_desc"] = "storageFull1_cafe_desc";
    IdLoca["storageFull1_desc"] = "storageFull1_desc";
    IdLoca["storageFull1_water_desc"] = "storageFull1_water_desc";
    IdLoca["storageFull2_desc"] = "storageFull2_desc";
    IdLoca["storageFull_desc"] = "storageFull_desc";
    IdLoca["storageFull_title"] = "storageFull_title";
    IdLoca["tapToContinue_web"] = "tapToContinue_web";
    IdLoca["taskX_of_Y"] = "taskX_of_Y";
    IdLoca["themedEvent_difficulty_title"] = "themedEvent_difficulty_title";
    IdLoca["themedEvent_difficulty_unlockRequ"] = "themedEvent_difficulty_unlockRequ";
    IdLoca["themedEventCompleted_eventInfo"] = "themedEventCompleted_eventInfo";
    IdLoca["themedEventCompleted_yourReward"] = "themedEventCompleted_yourReward";
    IdLoca["thresholdReward_collectingEvent_desc"] = "thresholdReward_collectingEvent_desc";
    IdLoca["timeDisplay_fullDays"] = "timeDisplay_fullDays";
    IdLoca["timeDisplay_longTimeExact"] = "timeDisplay_longTimeExact";
    IdLoca["timeDisplay_longTimeVague"] = "timeDisplay_longTimeVague";
    IdLoca["timeDisplay_shortTime"] = "timeDisplay_shortTime";
    IdLoca["tooltip_abtn_cafe_web"] = "tooltip_abtn_cafe_web";
    IdLoca["tooltip_abtn_collectEvent_web"] = "tooltip_abtn_collectEvent_web";
    IdLoca["tooltip_abtn_coopLvlUp_web"] = "tooltip_abtn_coopLvlUp_web";
    IdLoca["tooltip_abtn_coopProject_web"] = "tooltip_abtn_coopProject_web";
    IdLoca["tooltip_abtn_demotion_web"] = "tooltip_abtn_demotion_web";
    IdLoca["tooltip_abtn_dog_web"] = "tooltip_abtn_dog_web";
    IdLoca["tooltip_abtn_eventCompleted_web"] = "tooltip_abtn_eventCompleted_web";
    IdLoca["tooltip_abtn_newAdventure_web"] = "tooltip_abtn_newAdventure_web";
    IdLoca["tooltip_abtn_newCoopTournament_web"] = "tooltip_abtn_newCoopTournament_web";
    IdLoca["tooltip_abtn_newEvent_web"] = "tooltip_abtn_newEvent_web";
    IdLoca["tooltip_abtn_newPost_web"] = "tooltip_abtn_newPost_web";
    IdLoca["tooltip_abtn_newTournament_web"] = "tooltip_abtn_newTournament_web";
    IdLoca["tooltip_abtn_promotion_web"] = "tooltip_abtn_promotion_web";
    IdLoca["tooltip_abtn_rewards_web"] = "tooltip_abtn_rewards_web";
    IdLoca["tooltip_abtn_saveAccount_web"] = "tooltip_abtn_saveAccount_web";
    IdLoca["tooltip_abtn_tournamentRewards_web"] = "tooltip_abtn_tournamentRewards_web";
    IdLoca["tooltip_abtn_water_web"] = "tooltip_abtn_water_web";
    IdLoca["tooltip_adventureXp_web"] = "tooltip_adventureXp_web";
    IdLoca["tooltip_alreadyBottom_web"] = "tooltip_alreadyBottom_web";
    IdLoca["tooltip_alreadyTop_web"] = "tooltip_alreadyTop_web";
    IdLoca["tooltip_balloon_web"] = "tooltip_balloon_web";
    IdLoca["tooltip_btn_construct_web"] = "tooltip_btn_construct_web";
    IdLoca["tooltip_btn_noProject_web"] = "tooltip_btn_noProject_web";
    IdLoca["tooltip_btn_project_web"] = "tooltip_btn_project_web";
    IdLoca["tooltip_btn_quests_web"] = "tooltip_btn_quests_web";
    IdLoca["tooltip_btn_shops_web"] = "tooltip_btn_shops_web";
    IdLoca["tooltip_btn_storage_web"] = "tooltip_btn_storage_web";
    IdLoca["tooltip_buildingBonus_GreenArrowUpIcn"] = "tooltip_buildingBonus_GreenArrowUpIcn";
    IdLoca["tooltip_buildingBonus_HappinessPositiveIcn"] = "tooltip_buildingBonus_HappinessPositiveIcn";
    IdLoca["tooltip_buildingBonus_OutputIncreaseIcn"] = "tooltip_buildingBonus_OutputIncreaseIcn";
    IdLoca["tooltip_buildingBonus_WorkersIcn"] = "tooltip_buildingBonus_WorkersIcn";
    IdLoca["tooltip_buyForBuildCoupons_web"] = "tooltip_buyForBuildCoupons_web";
    IdLoca["tooltip_buyForDecoCoupons_web"] = "tooltip_buyForDecoCoupons_web";
    IdLoca["tooltip_buyForDollars_web"] = "tooltip_buyForDollars_web";
    IdLoca["tooltip_buyForGold_web"] = "tooltip_buyForGold_web";
    IdLoca["tooltip_buyForKeys_web"] = "tooltip_buyForKeys_web";
    IdLoca["tooltip_buyForPawPrints_web"] = "tooltip_buyForPawPrints_web";
    IdLoca["tooltip_buyForSpecialCoupons_web"] = "tooltip_buyForSpecialCoupons_web";
    IdLoca["tooltip_changeProfilePicture_web"] = "tooltip_changeProfilePicture_web";
    IdLoca["tooltip_choose_ranking"] = "tooltip_choose_ranking";
    IdLoca["tooltip_clickCollect_web"] = "tooltip_clickCollect_web";
    IdLoca["tooltip_clickOpen_web"] = "tooltip_clickOpen_web";
    IdLoca["tooltip_clickOptions_web"] = "tooltip_clickOptions_web";
    IdLoca["tooltip_collectReward_web"] = "tooltip_collectReward_web";
    IdLoca["tooltip_collectRewardAgain_web"] = "tooltip_collectRewardAgain_web";
    IdLoca["tooltip_collectRewardDouble_web"] = "tooltip_collectRewardDouble_web";
    IdLoca["tooltip_collectRewards_web"] = "tooltip_collectRewards_web";
    IdLoca["tooltip_connectedToFacebook_web"] = "tooltip_connectedToFacebook_web";
    IdLoca["tooltip_connectToFacebook_web"] = "tooltip_connectToFacebook_web";
    IdLoca["tooltip_constructionTime_web"] = "tooltip_constructionTime_web";
    IdLoca["tooltip_contactSupport_web"] = "tooltip_contactSupport_web";
    IdLoca["tooltip_coopPosition_web"] = "tooltip_coopPosition_web";
    IdLoca["tooltip_coopProfile_web"] = "tooltip_coopProfile_web";
    IdLoca["tooltip_coopProjects_eventTime"] = "tooltip_coopProjects_eventTime";
    IdLoca["tooltip_coopProjects_eventXpInfo"] = "tooltip_coopProjects_eventXpInfo";
    IdLoca["tooltip_coopProjects_xpInfo"] = "tooltip_coopProjects_xpInfo";
    IdLoca["tooltip_coopXp_web"] = "tooltip_coopXp_web";
    IdLoca["tooltip_deliveryInProgress_web"] = "tooltip_deliveryInProgress_web";
    IdLoca["tooltip_demolish_web"] = "tooltip_demolish_web";
    IdLoca["tooltip_doghouse_web"] = "tooltip_doghouse_web";
    IdLoca["tooltip_dollarDonation_notEnough"] = "tooltip_dollarDonation_notEnough";
    IdLoca["tooltip_down_web"] = "tooltip_down_web";
    IdLoca["tooltip_enterFeedbackFirst_web"] = "tooltip_enterFeedbackFirst_web";
    IdLoca["tooltip_eventHub_web"] = "tooltip_eventHub_web";
    IdLoca["tooltip_fasterConstrTime_web"] = "tooltip_fasterConstrTime_web";
    IdLoca["tooltip_fasterProdTime_web"] = "tooltip_fasterProdTime_web";
    IdLoca["tooltip_finishForGold_web"] = "tooltip_finishForGold_web";
    IdLoca["tooltip_fishingXp_web"] = "tooltip_fishingXp_web";
    IdLoca["tooltip_fulfillContract_web"] = "tooltip_fulfillContract_web";
    IdLoca["tooltip_getPremiumDogTreat_web"] = "tooltip_getPremiumDogTreat_web";
    IdLoca["tooltip_getPremiumDogTreatFull_web"] = "tooltip_getPremiumDogTreatFull_web";
    IdLoca["tooltip_giveFeedback_web"] = "tooltip_giveFeedback_web";
    IdLoca["tooltip_goldDonation_locked"] = "tooltip_goldDonation_locked";
    IdLoca["tooltip_goldDonation_notEnough"] = "tooltip_goldDonation_notEnough";
    IdLoca["tooltip_hud_fullscreen_web"] = "tooltip_hud_fullscreen_web";
    IdLoca["tooltip_hud_logout_web"] = "tooltip_hud_logout_web";
    IdLoca["tooltip_hud_minimize_web"] = "tooltip_hud_minimize_web";
    IdLoca["tooltip_hud_offers_web"] = "tooltip_hud_offers_web";
    IdLoca["tooltip_hud_zoomin_web"] = "tooltip_hud_zoomin_web";
    IdLoca["tooltip_hud_zoomout_web"] = "tooltip_hud_zoomout_web";
    IdLoca["tooltip_increaseLevel_web"] = "tooltip_increaseLevel_web";
    IdLoca["tooltip_kickMember_web"] = "tooltip_kickMember_web";
    IdLoca["tooltip_leagueReward_locked"] = "tooltip_leagueReward_locked";
    IdLoca["tooltip_library_web"] = "tooltip_library_web";
    IdLoca["tooltip_more_web"] = "tooltip_more_web";
    IdLoca["tooltip_moreInfo_web"] = "tooltip_moreInfo_web";
    IdLoca["tooltip_moreOptions_web"] = "tooltip_moreOptions_web";
    IdLoca["tooltip_move_web"] = "tooltip_move_web";
    IdLoca["tooltip_newQuest_web"] = "tooltip_newQuest_web";
    IdLoca["tooltip_notEnoughGold_web"] = "tooltip_notEnoughGold_web";
    IdLoca["tooltip_notEnoughItems_web"] = "tooltip_notEnoughItems_web";
    IdLoca["tooltip_nothingToSell_web"] = "tooltip_nothingToSell_web";
    IdLoca["tooltip_nursery_web"] = "tooltip_nursery_web";
    IdLoca["tooltip_placeFromInventory_web"] = "tooltip_placeFromInventory_web";
    IdLoca["tooltip_playerXp_web"] = "tooltip_playerXp_web";
    IdLoca["tooltip_pointsRequired"] = "tooltip_pointsRequired";
    IdLoca["tooltip_possibleRewards_web"] = "tooltip_possibleRewards_web";
    IdLoca["tooltip_prodTime_web"] = "tooltip_prodTime_web";
    IdLoca["tooltip_purchasePoints_web"] = "tooltip_purchasePoints_web";
    IdLoca["tooltip_questCompleted_web"] = "tooltip_questCompleted_web";
    IdLoca["tooltip_requirementsNotMet_web"] = "tooltip_requirementsNotMet_web";
    IdLoca["tooltip_rotate_web"] = "tooltip_rotate_web";
    IdLoca["tooltip_selectMember_web"] = "tooltip_selectMember_web";
    IdLoca["tooltip_setGoldConfirmation_web"] = "tooltip_setGoldConfirmation_web";
    IdLoca["tooltip_showMeDollars_web"] = "tooltip_showMeDollars_web";
    IdLoca["tooltip_showMeHelp_web"] = "tooltip_showMeHelp_web";
    IdLoca["tooltip_showMeQuest_web"] = "tooltip_showMeQuest_web";
    IdLoca["tooltip_showMeResource_web"] = "tooltip_showMeResource_web";
    IdLoca["tooltip_skipForGold_web"] = "tooltip_skipForGold_web";
    IdLoca["tooltip_startProd_web"] = "tooltip_startProd_web";
    IdLoca["tooltip_storageSpace_web"] = "tooltip_storageSpace_web";
    IdLoca["tooltip_timeRemaining_web"] = "tooltip_timeRemaining_web";
    IdLoca["tooltip_toCafe_web"] = "tooltip_toCafe_web";
    IdLoca["tooltip_toggleAmbientOff_web"] = "tooltip_toggleAmbientOff_web";
    IdLoca["tooltip_toggleAmbientOn_web"] = "tooltip_toggleAmbientOn_web";
    IdLoca["tooltip_toggleAnimationsOff_web"] = "tooltip_toggleAnimationsOff_web";
    IdLoca["tooltip_toggleAnimationsOn_web"] = "tooltip_toggleAnimationsOn_web";
    IdLoca["tooltip_toggleMusicOff_web"] = "tooltip_toggleMusicOff_web";
    IdLoca["tooltip_toggleMusicOn_web"] = "tooltip_toggleMusicOn_web";
    IdLoca["tooltip_toggleNotificationsOff_web"] = "tooltip_toggleNotificationsOff_web";
    IdLoca["tooltip_toggleNotificationsOn_web"] = "tooltip_toggleNotificationsOn_web";
    IdLoca["tooltip_toggleSoundOff_web"] = "tooltip_toggleSoundOff_web";
    IdLoca["tooltip_toggleSoundOn_web"] = "tooltip_toggleSoundOn_web";
    IdLoca["tooltip_toInventory_web"] = "tooltip_toInventory_web";
    IdLoca["tooltip_toMarket_web"] = "tooltip_toMarket_web";
    IdLoca["tooltip_toNursery_web"] = "tooltip_toNursery_web";
    IdLoca["tooltip_topOfRanking_web"] = "tooltip_topOfRanking_web";
    IdLoca["tooltip_tournaments_web"] = "tooltip_tournaments_web";
    IdLoca["tooltip_trashContract_web"] = "tooltip_trashContract_web";
    IdLoca["tooltip_up_web"] = "tooltip_up_web";
    IdLoca["tooltip_upgradeLibrary_web"] = "tooltip_upgradeLibrary_web";
    IdLoca["tooltip_upgradeMarket_web"] = "tooltip_upgradeMarket_web";
    IdLoca["tooltip_upgradeMax_web"] = "tooltip_upgradeMax_web";
    IdLoca["tooltip_upgradeTime_web"] = "tooltip_upgradeTime_web";
    IdLoca["tooltip_useDogTreat_web"] = "tooltip_useDogTreat_web";
    IdLoca["tooltip_useDogTreatInProgress_web"] = "tooltip_useDogTreatInProgress_web";
    IdLoca["tooltip_useHumus_web"] = "tooltip_useHumus_web";
    IdLoca["tooltip_visitPlayer_web"] = "tooltip_visitPlayer_web";
    IdLoca["tooltip_waitForFinish_web"] = "tooltip_waitForFinish_web";
    IdLoca["tooltip_watchAdToSkip_web"] = "tooltip_watchAdToSkip_web";
    IdLoca["tooltip_workers_web"] = "tooltip_workers_web";
    IdLoca["tooltip_yourPosition_web"] = "tooltip_yourPosition_web";
    IdLoca["tooltip_getReward_web"] = "tooltip_getReward_web";
    IdLoca["tooltip_goldSum"] = "tooltip_goldSum";
    IdLoca["tooltip_goldSum_OfferValue"] = "tooltip_goldSum_OfferValue";
    IdLoca["tooltip_goldSum_extraGold"] = "tooltip_goldSum_extraGold";
    IdLoca["tooltip_goldSum_subscriptionBonus"] = "tooltip_goldSum_subscriptionBonus";
    IdLoca["tooltip_goldSum_PrimeTimeBonus"] = "tooltip_goldSum_PrimeTimeBonus";
    IdLoca["tooltip_goldSum_webBonus"] = "tooltip_goldSum_webBonus";
    IdLoca["coopChat_maxCharacters_web"] = "coopChat_maxCharacters_web";
    IdLoca["timeDisplay_xDays"] = "timeDisplay_xDays";
    IdLoca["timeDisplay_xHours"] = "timeDisplay_xHours";
    IdLoca["timeDisplay_xMinutes"] = "timeDisplay_xMinutes";
    IdLoca["topRewards"] = "topRewards";
    IdLoca["tournamentMenu_coop_desc"] = "tournamentMenu_coop_desc";
    IdLoca["tournamentMenu_coop_title"] = "tournamentMenu_coop_title";
    IdLoca["tournamentMenu_player_desc"] = "tournamentMenu_player_desc";
    IdLoca["tournamentMenu_player_title"] = "tournamentMenu_player_title";
    IdLoca["tournamentReward_coop_summedRankings"] = "tournamentReward_coop_summedRankings";
    IdLoca["tournamentReward_coop_summedThresholds"] = "tournamentReward_coop_summedThresholds";
    IdLoca["tournamentReward_player"] = "tournamentReward_player";
    IdLoca["tournamentReward_player_summedRankings"] = "tournamentReward_player_summedRankings";
    IdLoca["tournamentReward_player_summedThresholds"] = "tournamentReward_player_summedThresholds";
    IdLoca["tournamentTeaser_joinCoop_desc"] = "tournamentTeaser_joinCoop_desc";
    IdLoca["tournamentTeaser_levelTooLow_coop_desc"] = "tournamentTeaser_levelTooLow_coop_desc";
    IdLoca["tournamentTeaser_levelTooLow_player_desc"] = "tournamentTeaser_levelTooLow_player_desc";
    IdLoca["tournamentTeaser_nothingRunning_desc"] = "tournamentTeaser_nothingRunning_desc";
    IdLoca["tournamentTeaser_nothingRunning_title"] = "tournamentTeaser_nothingRunning_title";
    IdLoca["tournamentRewardPlayerTitle"] = "tournamentReward_player_title";
    IdLoca["tournamentRewardCoopTitle"] = "tournamentReward_coop_title";
    IdLoca["tournamentRewardCollectTitle"] = "tournamentReward_collect_title";
    IdLoca["traderEvent_title"] = "traderEvent_title";
    IdLoca["traderEvent_desc"] = "traderEvent_desc";
    IdLoca["traderEvent_finalReward_desc"] = "traderEvent_finalReward_desc";
    IdLoca["tutorial_checkNewQuest1"] = "tutorial_checkNewQuest1";
    IdLoca["tutorial_collectQuestReward1"] = "tutorial_collectQuestReward1";
    IdLoca["tutorial_constructWindmill1"] = "tutorial_constructWindmill1";
    IdLoca["tutorial_constructWindmill3"] = "tutorial_constructWindmill3";
    IdLoca["tutorial_constructWindmill4"] = "tutorial_constructWindmill4";
    IdLoca["tutorial_constructWindmill5"] = "tutorial_constructWindmill5";
    IdLoca["tutorial_constructWindmill6"] = "tutorial_constructWindmill6";
    IdLoca["tutorial_feedChicken"] = "tutorial_feedChicken";
    IdLoca["tutorial_finished"] = "tutorial_finished";
    IdLoca["tutorial_harvestCorn"] = "tutorial_harvestCorn";
    IdLoca["tutorial_harvestWildflowers"] = "tutorial_harvestWildflowers";
    IdLoca["tutorial_produceChickenFeed1"] = "tutorial_produceChickenFeed1";
    IdLoca["tutorial_produceChickenFeed2"] = "tutorial_produceChickenFeed2";
    IdLoca["tutorial_sowWildflowers1"] = "tutorial_sowWildflowers1";
    IdLoca["tutorial_sowWildflowers3"] = "tutorial_sowWildflowers3";
    IdLoca["tutorial_sowWildflowers4"] = "tutorial_sowWildflowers4";
    IdLoca["tutorial_welcome"] = "tutorial_welcome";
    IdLoca["upgrade"] = "upgrade";
    IdLoca["value_nominal_add"] = "value_nominal_add";
    IdLoca["value_nominal_subtract"] = "value_nominal_subtract";
    IdLoca["value_percentage"] = "value_percentage";
    IdLoca["value_percentage_add"] = "value_percentage_add";
    IdLoca["value_percentage_subtract"] = "value_percentage_subtract";
    IdLoca["value_proportional_value"] = "value_proportional_value";
    IdLoca["value_nominal_multiply"] = "value_nominal_multiply";
    IdLoca["watertower"] = "watertower";
    IdLoca["watertowerMenu_desc1"] = "watertowerMenu_desc1";
    IdLoca["welcomeBackGift_desc"] = "welcomeBackGift_desc";
    IdLoca["welcomeBackGift_title"] = "welcomeBackGift_title";
    IdLoca["welcomeGift"] = "welcomeGift";
    IdLoca["xHappiness"] = "xHappiness";
    IdLoca["yourReward"] = "yourReward";
    IdLoca["floatingText_coopFull"] = "floatingText_coopFull";
    IdLoca["help_missingPlayerlevel_title"] = "help_missingPlayerlevel_title";
    IdLoca["expansionDiscountDialog_title"] = "expansionDiscountDialog_title";
    IdLoca["expansionDiscountDialog_desc"] = "expansionDiscountDialog_desc";
    IdLoca["floatingText_requBuildingLevel"] = "floatingText_requBuildingLevel";
    IdLoca["floatingText_noPointsToCollect"] = "floatingText_noPointsToCollect";
    IdLoca["floatingText_onlyLeaderDeputies"] = "floatingText_onlyLeaderDeputies";
    IdLoca["floatingText_onlyOneProject"] = "floatingText_onlyOneProject";
    IdLoca["xInTotal"] = "xInTotal";
    IdLoca["xTimes"] = "xTimes";
    IdLoca["purchaseOfferBonusPercentage"] = "purchaseOffer_bonusPercentage";
    IdLoca["tournamentDialogPlayerPromotion"] = "tournamentDialog_player_promotion";
    IdLoca["tournamentDialogCoopPromotion"] = "tournamentDialog_coop_promotion";
    IdLoca["tournamentDialogCollectPromotion"] = "tournamentDialog_collect_promotion";
    IdLoca["tournamentDialogPlayerDemotion"] = "tournamentDialog_player_demotion";
    IdLoca["tournamentDialogCoopDemotion"] = "tournamentDialog_coop_demotion";
    IdLoca["tournamentDialogCollectDemotion"] = "tournamentDialog_collect_demotion";
    IdLoca["leagueMenuCategoryRewards"] = "leagueMenu_categoryRewards";
    IdLoca["fancyHouseDiscountDialog_title"] = "fancyHouseDiscountDialog_title";
    IdLoca["fancyHouseDiscountDialog_desc"] = "fancyHouseDiscountDialog_desc";
    IdLoca["fertileAcreDiscountDialog_title"] = "fertileAcreDiscountDialog_title";
    IdLoca["fertileAcreDiscountDialog_desc"] = "fertileAcreDiscountDialog_desc";
    IdLoca["settingsMenu_animationsOn"] = "settingsMenu_animationsOn";
    IdLoca["settingsMenu_animationsOff"] = "settingsMenu_animationsOff";
    IdLoca["ggsAnniversary10_desc"] = "ggsAnniversary10_desc";
    IdLoca["ggsAnniversary10_title"] = "ggsAnniversary10_title";
    IdLoca["primeTimeDialog_title"] = "primeTimeDialog_title";
    IdLoca["primeTimeDialog_desc"] = "primeTimeDialog_desc";
    IdLoca["mysteryChestRewardDialog_pictureDuplicate"] = "mysteryChestRewardDialog_pictureDuplicate";
    IdLoca["externalBarn"] = "externalBarn";
    IdLoca["externalBarnDiscountDialog_desc"] = "externalBarnDiscountDialog_desc";
    IdLoca["externalBarnDiscountDialog_title"] = "externalBarnDiscountDialog_title";
    IdLoca["externalBarn_desc"] = "externalBarn_desc";
    IdLoca["externalBarn_upgradeDesc"] = "externalBarn_upgradeDesc";
    IdLoca["goldSum_includeWebBonus"] = "goldSum_includeWebBonus";
    IdLoca["goldSum_contentWorth"] = "goldSum_contentWorth";
    IdLoca["buttonBacktoOffers_web"] = "buttonBacktoOffers_web";
    IdLoca["webGiftDialog_title_web"] = "webGiftDialog_title_web";
    IdLoca["webGiftDialog_desc_web"] = "webGiftDialog_desc_web";
    IdLoca["birthdayCelebration_title"] = "birthdayCelebration_title";
    IdLoca["birthdayCelebration_desc"] = "birthdayCelebration_desc";
    IdLoca["bees"] = "bees";
    IdLoca["exp"] = "exp";
})(IdLoca || (IdLoca = {}));



//////////////////
// WEBPACK FOOTER
// ./src/utils/i18n/IdLoca.ts
// module id = 6
// module chunks = 3